export default __webpack_public_path__ + "static/media/manual11.1fef4a06.png";